
import { defineComponent, PropType } from 'vue'
import { Theme } from '~/types/theme'
import AppTransition from '~/components/AppTransition'

export default defineComponent({
  name: 'NewsletterSignupStepLayout',
  components: { AppTransition },
  props: {
    theme: {
      type: String as PropType<Theme>,
      default: 'light',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
})
